// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-3bd84004408ceabe.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"1167":"01d2aefe0f3c9201","2937":"e7601066ca3501ac","4033":"fb38a1ed6b5c0aef","6350":"bd7c49e260a249ea","7856":"07998b6df681f356"}[chunkId] + ".js";
};